import { TmApiClientError } from '@/core/error/transport/tmApiClientError'

export class TmApiTwilioNotEnoughPermissionError extends TmApiClientError {
  public name = 'TmApiTwilioNotEnoughPermissionError'

  public shouldBeMonitored(): boolean {
    return false
  }
}
